(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wm-product-size-guide"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('wm-fit-size-guide')){
    customElements.define('wm-fit-size-guide',class extends HTMLElement{
      connectedCallback(){
        this.wmAbort?.abort();
        this.wmAbort=new AbortController();
        this.addEventListener('click',event=>{
          const dialog=this.querySelector('.wm-fit-dialog');
          const button=event.target.closest('button');
          if(button?.hasAttribute('data-wm-guide-open')){event.preventDefault();if(!dialog.open)dialog.showModal();}
          if(button?.hasAttribute('data-wm-guide-close'))dialog.close();
          if(button?.hasAttribute('data-wm-unit')){
            const unit=button.dataset.wmUnit;
            const locale=this.dataset.locale||'en';
            const format=new Intl.NumberFormat(locale,{maximumFractionDigits:1});
            this.querySelectorAll('[data-wm-cm]').forEach(cell=>{const cm=Number(cell.dataset.wmCm);cell.textContent=format.format(unit==='cm'?cm:Number((cm/2.54).toFixed(1)));});
            this.querySelectorAll('[data-wm-unit]').forEach(control=>control.setAttribute('aria-pressed',String(control.dataset.wmUnit===unit)));
            this.querySelector('[data-wm-current-unit]').textContent=unit==='cm'?'cm':button.textContent.trim().toLowerCase();
          }
          if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}
        },{signal:this.wmAbort.signal});
      }
      disconnectedCallback(){this.wmAbort?.abort();}
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wm-visual-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wm-visual-menu')) {
    customElements.define('wm-visual-menu', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.dialog = this.querySelector('dialog');
        this.tabs = [...this.querySelectorAll('[data-wm-tab]')];
        this.panels = [...this.querySelectorAll('[data-wm-panel-content]')];
        if (!this.dialog || !this.tabs.length) return;
        document.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-wm-menu-open]');
          if (!trigger || trigger.dataset.wmMenuOpen !== this.dialog.id || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.trigger = trigger;
          this.selectPanel(Number(trigger.dataset.wmPanel) || 0);
          if (!this.dialog.open) {
            this.previousOverflow = document.body.style.overflow;
            this.dialog.showModal();
            document.body.style.overflow = 'hidden';
          }
          trigger.setAttribute('aria-expanded', 'true');
          this.tabs[this.activeIndex].focus({ preventScroll: true });
        }, options);
        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[data-wm-tab]');
          if (tab) this.selectPanel(Number(tab.dataset.wmTab));
          if (event.target.closest('[data-wm-close]') || event.target === this.dialog) this.dialog.close();
        }, options);
        this.addEventListener('keydown', (event) => {
          const tab = event.target.closest('[data-wm-tab]');
          if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let index = this.activeIndex;
          if (event.key === 'ArrowRight') index = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') index = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = this.tabs.length - 1;
          this.selectPanel(index);
          this.tabs[index].focus({ preventScroll: true });
        }, options);
        this.dialog.addEventListener('close', () => {
          this.restoreScroll();
          if (this.trigger?.isConnected) {
            this.trigger.setAttribute('aria-expanded', 'false');
            this.trigger.focus({ preventScroll: true });
          }
        }, options);
      }
      selectPanel(index) {
        this.activeIndex = index >= 0 && index < this.tabs.length ? index : 0;
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === this.activeIndex));
          tab.tabIndex = i === this.activeIndex ? 0 : -1;
        });
        this.panels.forEach((panel, i) => { panel.hidden = i !== this.activeIndex; });
      }
      restoreScroll() {
        if (this.previousOverflow !== undefined) {
          document.body.style.overflow = this.previousOverflow;
          this.previousOverflow = undefined;
        }
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.restoreScroll();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wm-vital-size-guide"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('wm-vital-size-guide')){
    customElements.define('wm-vital-size-guide',class extends HTMLElement{
      connectedCallback(){
        this.wmAbort?.abort();
        this.wmAbort=new AbortController();
        this.addEventListener('click',event=>{
          const dialog=this.querySelector('.wm-vital-dialog');
          const button=event.target.closest('button');
          if(button?.hasAttribute('data-wm-guide-open')){event.preventDefault();if(!dialog.open)dialog.showModal();}
          if(button?.hasAttribute('data-wm-guide-close'))dialog.close();
          if(button?.hasAttribute('data-wm-unit')){
            const unit=button.dataset.wmUnit;
            const locale=this.dataset.locale||'en';
            const format=new Intl.NumberFormat(locale,{maximumFractionDigits:1});
            this.querySelectorAll('[data-wm-cm]').forEach(cell=>{const cm=Number(cell.dataset.wmCm);cell.textContent=format.format(unit==='cm'?cm:Number((cm/2.54).toFixed(1)));});
            this.querySelectorAll('[data-wm-unit]').forEach(control=>control.setAttribute('aria-pressed',String(control.dataset.wmUnit===unit)));
            this.querySelector('[data-wm-current-unit]').textContent=unit==='cm'?'cm':button.textContent.trim().toLowerCase();
          }
          if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}
        },{signal:this.wmAbort.signal});
      }
      disconnectedCallback(){this.wmAbort?.abort();}
    });
  }
  } catch(e) { console.error(e); }
})();

})();
